module.exports = __webpack_public_path__ + "static/img/sdl_image@3x.d8182d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/3x/sdl_image@3x.png
// module id = sfbs
// module chunks = 1